/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Reingest_Error_DescInputs */

const es_settings_files_toast_reingest_error_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo re-ingestar el archivo.`)
};

const en_settings_files_toast_reingest_error_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not re-ingest the file.`)
};

/**
* | output |
* | --- |
* | "Could not re-ingest the file." |
*
* @param {Settings_Files_Toast_Reingest_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_error_desc = /** @type {((inputs?: Settings_Files_Toast_Reingest_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_error_desc(inputs)
	return en_settings_files_toast_reingest_error_desc(inputs)
});
export { settings_files_toast_reingest_error_desc as "settings.files.toast.reingest_error_desc" }